module.exports = __webpack_public_path__ + "media/images/prevention_form/stress-877f298f6336bb715e27704f8e104810.svg";